// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__255Uk","footer":"ModalInfo_footer__1T5EN"};